/* eslint-disable import/no-anonymous-default-export */
export default (locationItem = [], action) => {
  switch (action.type) {
    case "UPDATE_LOCATION_ITEM":
      return locationItem.map((d) => (d._id === action.payload?._id ? action.payload : d));
    case "LOCATION_ITEMS":
      return action.payload;
    case "DELETE_LOCATION_ITEM":
      return locationItem.filter((data) => data._id !== action.payload);

    default:
      return locationItem;
  }
};
